import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, output, TemplateRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NgTemplateOutlet} from '@angular/common';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatIcon} from '@angular/material/icon';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {switchMap} from 'rxjs';
import {ApiService} from '../../../../modules/apiModule1/api/ApiService';
import {MAT_DIALOG_METHOD, MAT_DIALOG_SERVICE} from '../../../../app.config';
import {MatRadioButton} from '@angular/material/radio';

@Component({
  selector: 'pas-multi-select3-dialog',
  standalone: true,
  imports: [
    MatCheckbox,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
    MatButton,
    MatRadioButton,
    NgTemplateOutlet
  ],
  templateUrl: './multi-select3-dialog.component.html',
  styleUrl: './multi-select3-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiSelect3DialogComponent {
  items: any[] = [];
  type: string;
  options: object = {};
  template: TemplateRef<any>|null = null;

  selectedItems: any[] = [];
  filteredItems = [...this.items];
  searchTerm = new FormControl('');
  commonItemsWithSelected: (IndexEntry & { selected: boolean })[] = [];

  worker = new Worker(new URL('./compare.worker', import.meta.url));

  constructor(
    private dialogRef: MatDialogRef<MultiSelect3DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_SERVICE) private indexService: ApiService,
    @Inject(MAT_DIALOG_METHOD) private method: string,
    // private indexService: IndexEntityService,
    private cdr: ChangeDetectorRef
  ) {
    this.selectedItems = data.items;
    this.template = data.template||null;
    this.type = data.type||'checkbox';
    (this.indexService as any)[method]({filteredObjectName:this.data['filteredObjectName'],...data.options}).subscribe(({values}: { values: any[] }) => {
      this.items = values;
      this.filterItems()
      this.worker.postMessage([this.selectedItems, this.items])
    })
    this.filterItems();
    this.worker.onmessage = (event) => {
      this.commonItemsWithSelected = event.data;
      this.items = this.commonItemsWithSelected;
      this.filterItems();
      this.cdr.markForCheck();
    }
    this.searchTerm.valueChanges
      .pipe(switchMap(term => (this.indexService as any)[method]({filteredObjectName:this.data['filteredObjectName'], searchString: term||'', ...data.options})))
      .subscribe((v:any) => {
        v && v.values && (this.items = v.values);
        this.filterItems()
        this.worker.postMessage([this.selectedItems, this.items])
      })
  }

  apply() {
    // Действия при нажатии "Применить"
    this.dialogRef.close(this.selectedItems);
  }

  close() {
    this.dialogRef.close();
  }

  reset() {
    // Сбросить выбор
    this.selectedItems = [];
    this.worker.postMessage([this.selectedItems, this.items])
  }

  filterItems() {
    // if (!this.searchTerm.value) {
    //   this.filteredItems = [...this.items];
    // } else {
    //   this.filteredItems = this.items.filter(item =>
    //     item.name.toLowerCase().includes(this.searchTerm.value?.toLowerCase())
    //   );
    // }
    this.filteredItems = [...this.items]
  }

  isSelected(item: any): boolean {
    // return this.selectedItems.some(i => i.id === item.id);
    return item.selected;
  }

  toggleSelection(item: any) {
    const index = this.selectedItems.findIndex(i => (typeof i === 'object') &&
                                                                  ('id' in i) &&
                                                                  i.id === item.id);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.type !== 'radio'
        ? this.selectedItems.push(item)
        : this.selectedItems=[item]
    }
  }

  protected readonly output = output;
}
